// Services
import CommandesService from '@/services/01Cell/CommandesService'

export const MyOrders = {
    data () {
        return {
          status: [
              {
                item: this.$i18n.t('order.status.Open'),
                valeur: 1,
              },
              {
                item: this.$i18n.t('order.status.Confirmation_request'),
                valeur: 2,
              },
              {
                item: this.$i18n.t('order.status.Confirmed'),
                valeur: 3,
              },
              {
                item: this.$i18n.t('order.status.Migrated_Activated'),
                valeur: 4,
              },
              {
                item: this.$i18n.t('order.status.Delivered_Completed'),
                valeur: 5,
              },
          ],
        }
    },

    computed: {
      getOrderCodeName () {
        if (this.$company === 'uqam' || this.$company === 'demo') return 'UBR'
        else return this.$i18n.t('order.Payable_billing_code')
      },
    },

    methods: {
      getApprobation (responsableEmail) {
        // Si il n'y a pas de courriel, on ne fait pas d'approbation
        if (!responsableEmail.length) return false
        // Si on se trouve soi-même comme approbateur pas besoin d'approbation
        const findUser = responsableEmail.find(item => item === this.userInfo.info.mail)
        // return true or false
        return !findUser
      },
      async confirmCommandeModePaiment1 (order, showDialog) {
        let mustApprove = false
        // On va chercher le (les) responsable
        const responsableEmail = await CommandesService.responsableCodeFacturation(order.code_facturation)

        // Si c'est la personne qui est responsable, elle n'a pas besoin d'approbation
        mustApprove = this.getApprobation(responsableEmail)

        if (mustApprove) {
          // On confirme la commande
          const data = { date_confirmee: Date.now(), statut: 2, etape: 3, responsableUBR: responsableEmail }
          await CommandesService.confirmOrder(order.id, data)

          // Message pour le client
          if (showDialog) {
            const message = responsableEmail.length ? this.messageConfirmation[this.language].replace('[|COMMANDES_RESPONSABLE_CODE_FACTURATION|]', responsableEmail) : null

            // Ouvre un dialog pour informer le client
            this.$dialog.show({ message: message, print: false, html: true, iconState: true, iconColor: 'success', iconName: 'mdi-check-circle' })
          }
        } else {
          // Statut et Étape
          this.getNextStatutStep(order)
          const { statut, etape } = this.getNextStatutStep(order)
          const data = { date_confirmee: Date.now(), statut, etape }
          await CommandesService.update(data, order.id)
        }
      },
      getNextStatutStep (item) {
        // Nouvelle ligne
        if (item.type === 1) {
          // Si il y a déjà une carte SIM
          if (item.no_carte_sim) {
            return { statut: 3, etape: 5 }
          } else {
            // Pas de carte sim
            if (!item.livraison) return { statut: 3, etape: 1 }
            if (item.livraison) return { statut: 3, etape: 5 }
          }
        }
        if (item.type === 2) {
          if (item.migration_type === 1) return { statut: 2, etape: 2 }
          if (item.migration_type === 2) return { statut: 3, etape: item.livraison ? 6 : 2 }
          if (item.migration_type === 3) return { statut: 3, etape: item.livraison ? 6 : 2 }
        }
        if (item.type === 3) {
          if (item.type_equipement === 1) return { statut: 3, etape: 1 }
          if (item.type_equipement === 2) {
            // Si livraison
            if (item.livraison) return { statut: 3, etape: 1 }
            // Pas de livraison
            if (!item.livraison) return { statut: 3, etape: 3 }
          }
        }
      },
    },
}
